<template>
  <div>
    <fieldset class="mb-2">
      <legend class="sr-only">
        {{ multiSelect ? $t('classbook.notices.create.categories') : $t('classbook.filters.filter') }}
      </legend>
      <div class="group-selected-item-wrapper">
        <template v-if="multiSelect">
          <SCheckbox
            v-for="item in normalizedTypes"
            :key="`group-select-${item.value}`"
            v-model="item.selected"
            :data-cy="`group-select-${item.text}`"
            :name="`group-chk-select-${item.value}`"
            checkbox-type="btn"
            :label-text="item.text"
            @click="(event) => selectCheckBoxItem(item.value, event)"
          ></SCheckbox>
        </template>

        <template v-else>
          <SRadioButton
            v-for="item in normalizedTypes"
            :key="`group-select-${item.value}`"
            :data-cy="`group-select-${item.text}`"
            :currently-selected-value="localSelected"
            :name="`group-radio-select-${item.value}`"
            :value-on-selection="item.value"
            :label-text="item.text"
            radio-button-type="btn"
            @change="(newValue) => (localSelected = newValue)"
          ></SRadioButton>
        </template>

        <b-button
          v-if="!!customFilterModalType"
          data-cy="custom-filter-btn"
          size="sm"
          pill
          :variant="isActiveCustomFilter ? 'primary' : 'link'"
          @click="activateCustomFilterMode"
        >{{ customFilterModalType.name }}</b-button>
      </div>
    </fieldset>
  </div>
</template>

<script>
import SRadioButton from 'src/components/base/SRadioButton.vue'
import SCheckbox from 'src/components/base/SCheckbox.vue'
import { filterTypes } from 'src/composables/classbook/useClassbookFilter.ts'

export default {
  // TODO VUE3: Remove compatConfig when @vue/compat is removed
  compatConfig: {
    COMPONENT_V_MODEL: false,
  },

  name: 'SduiGroupSelect',

  components: { SRadioButton, SCheckbox },

  props: {
    selectOneOnload: {
      type: Boolean,
      default: false,
    },

    options: {
      type: Array,
      required: true,
    },

    currentFilterType: {
      type: [Array, String, Number],
      default: () => [],
    },

    multiSelect: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    localSelected: [],
    filterTypes: filterTypes,
  }),

  computed: {
    normalizedLocalSelected() {
      return Array.isArray(this.localSelected) ? this.localSelected : [this.localSelected]
    },

    normalizedTypes() {
      return this.options
        .filter((option) => option.id !== filterTypes.custom && !option.hidden)
        .map((s) => {
          return {
            text: s.name,
            value: s.uuid || s.id,
            hidden: s.hidden || false,
            selected: this.multiSelect ? this.localSelected.some((el) => el === s.uuid) : undefined,
          }
        })
    },

    customFilterModalType() {
      return this.options.find((option) => option.id === filterTypes.custom)
    },

    isActiveCustomFilter() {
      return this.currentFilterType === filterTypes.custom
    },
  },

  emits: ['update:modelValue', 'filter-changed', 'custom-filter-active', 'filter-type-changed'],

  methods: {
    activateCustomFilterMode() {
      this.$emit('custom-filter-active')
    },

    selectCheckBoxItem(itemValue, event) {
      if (event.target.checked) {
        this.localSelected.push(itemValue)
      } else {
        this.localSelected = this.localSelected.filter((el) => el !== itemValue)
      }
    },
  },

  watch: {
    localSelected: {
      handler(val) {
        if (val === filterTypes.custom) return
        this.$emit('filter-type-changed', val)
      },
    },

    currentFilterType: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length && newVal.every((v, i) => v === this.normalizedLocalSelected[i])) return

        this.localSelected = newVal

        if (this.selectOneOnload && !this.localSelected.length) {
          this.localSelected = this.multiSelect ? [this.normalizedTypes[0].value] : this.normalizedTypes[0].value
        }
      },

      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
.group-selected-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
